import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { TaskResource, TaskResourceNode } from '@app/interfaces/lm/kanban-board';
import { ResourceType } from '@app/interfaces/rm/resources';
import { ResourcesService } from '@services/rm/resources.service';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { NzTreeSelectComponent } from 'ng-zorro-antd/tree-select';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-resource-tree-select',
  templateUrl: './resource-tree-select.component.html',
  styleUrl: './resource-tree-select.component.less',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ResourceTreeSelectComponent),
      multi: true,
    },
  ],
})
export class ResourceTreeSelectComponent implements OnInit {
  @ViewChild('treeSelect') treeSelect!: NzTreeSelectComponent;
  @Input() options: string[] = [];
  @Input() isAll = false;  // 是否显示全部的资源
  @Input() required = false;
  @Input() formControlName = '';
  @Input() clickToEdit = false; // 点击后才编辑
  @Input() value: TaskResource[] = [];
  @Output() editSuccess = new EventEmitter();
  @Output() cancelEvent = new EventEmitter();
  @Output() closeLoadEvent = new EventEmitter();
  nodes: TaskResourceNode[] = [];
  resourceTypes: ResourceType[] = [];
  data: string[] = [];
  currentValue: TaskResource[] = [];
  isEditing = false;
  lastValue: TaskResource[] = [];
  saveLoading = false;
  timer: number | null = null;
  loading = false;

  constructor(private resourcesService: ResourcesService,
              private message: NzMessageService) {
  }

  get displayValue(): string {
    return (this.currentValue || []).map(it => it.name).join(',');
  }

  async ngOnInit(): Promise<void> {
    if (this.formControlName) {
      await this.fetchData();
    }
    this.initData();
  }

  async fetchData(): Promise<void> {
    try {
      this.loading = true;
      await this.getResourceType();
      await this.getResourceNodes();
    } finally {
      this.loading = false;
    }
  }

  onChange: any = () => {
  }
  onTouch: () => void = () => null;

  setData(): void {
    this.data = (this.currentValue || []).map(it => it.hardwareId);
  }

  writeValue(obj: any): void {
    this.currentValue = obj || [];
    this.setData();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  initData(): void {
    this.currentValue = this.value;
    this.setData();
    console.log('initData', this.nodes, this.data);
  }

  changeSelect(arr: string[]): void {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    this.timer = window.setTimeout(() => {
      const checkedNodes = this.treeSelect?.getCheckedNodeList() || [];
      const data = checkedNodes.map(it => {
        return {
          ...it?.origin?.resourceInfo
        };
      });
      this.currentValue = data;
      this.onChange(this.currentValue);
    }, 200);
  }

  async startEditing(): Promise<void> {
    await this.fetchData();
    this.initData();
    this.lastValue = [...this.currentValue];
    this.isEditing = true;
    setTimeout(() => {
      if (this.treeSelect) {
        this.treeSelect.openDropdown();
      }
    }, 1000);
  }

  async getResourceType(): Promise<void> {
    this.resourceTypes = await this.resourcesService.findAllResourceType();
  }

  /** 获取所有资源的格式化node */
  getAllResourceNodes(): any[] {
    const nodes: any = [];
    this.resourceTypes.forEach(it => {
      const resourceKey = it?.key as string;
      const isCustomResource = resourceKey.indexOf('RESOURCE_INSTANCE') !== -1;
      const resourceType = isCustomResource ? `${resourceKey}_${it?.value}` : resourceKey;
      if (!this.isAll && !(this.options || []).includes(resourceType)) {
        return;
      }
      const value = isCustomResource ? it.value : undefined;
      this.resourcesService.findResourceListByType(resourceKey, value).then((arr) => {
        nodes.push({
          title: it?.label,
          value: resourceType,
          key: resourceType,
          disableCheckbox: true,
          children: arr.map(xx => {
            const resourceInstance = xx?.resourceInstance;
            const hardwareId = isCustomResource ? xx.hardwareId : resourceInstance?.hardwareId;
            return {
              title: xx.name,
              value: hardwareId,
              key: hardwareId,
              isLeaf: true,
              resourceInfo: {
                resourceInstanceId: isCustomResource ? xx.resourceDefinitionId : resourceInstance.id,
                hardwareId,
                hardwareType: isCustomResource ? xx.hardwareType : resourceInstance?.hardwareType,
                name: isCustomResource ? xx.name : resourceInstance?.name
              }
            };
          })
        });
      });
    });
    return nodes;
  }

  async getResourceNodes(): Promise<void> {
    const nodes = await this.getAllResourceNodes();
    this.nodes = nodes;
  }

  handleSave(): void {
    if (this.required && (!this.currentValue || this.currentValue.length === 0)) {
      this.message.error('Input is required!');
      return;
    }
    this.isEditing = false;
    if (this.currentValue !== this.value) {
      this.editSuccess.emit(this.currentValue);
    }
  }

  handleCancel(): void {
    this.currentValue = this.lastValue;
    this.isEditing = false;
    this.cancelEvent.emit();
  }
}
